import request from "@/utils/request";

let Distribution = {
  /*等级列表*/
  getList(data, errorback) {
    return request._get("/shop/AgentGrade/AgentGrade/getList", data, errorback);
  },
  /*查询分销设置1.0*/
  getSettingOne(data, errorback) {
    return request._get("/shop/AgentGrade/AgentGrade/getSettingOne", data, errorback);
  },
    /*查询激活数量设置*/
    getSettingActive(data, errorback) {
      return request._get("/shop/AgentGrade/AgentGrade/getSettingActive", data, errorback);
    },
  /*查询分销设置*/
  getSetting(data, errorback) {
    return request._get("/shop/AgentGrade/AgentGrade/getSetting", data, errorback);
  },
  /*设置分销设置*/
  setting (data, errorback) {
    return request._postBody('/shop/AgentGrade/AgentGrade/setting', data, errorback);
  },
  /*升级条件配置*/
  settingLevel (data, errorback) {
    return request._postBody('/shop/AgentGrade/AgentGrade/settingLevel', data, errorback);
  },
  /*手动新增分销商*/
  agentListAdd (data, errorback) {
    return request._postBody('/shop/UserAgent/UserAgent/add', data, errorback);
  },
  /*分销商列表*/
  agentList (data, errorback) {
    return request._postBody('/shop/UserAgent/UserAgent/index', data, errorback);
  },
  /*获取下级分销商*/
  getLevelUser (data, errorback) {
    return request._postBody('/shop/UserAgent/UserAgent/getLevelUser', data, errorback);
  },
  /*新增分销商获取用户*/
  getUserList (data, errorback) {
    return request._postBody('/shop/UserAgent/UserAgent/userList', data, errorback);
  },
  /*手动升级分销商*/
  handLevel (data, errorback) {
    return request._postBody('/shop/UserAgent/UserAgent/handLevel', data, errorback);
  },
  /*删除分销商*/
  delAgentUser (data, errorback) {
    return request._postBody('/shop/UserAgent/UserAgent/delAgentUser', data, errorback);
  },
  /*升级日志列表*/
  getAgentGradeLog (data, errorback) {
    return request._postBody('/shop/AgentGradeLog/AgentGradeLog/index', data, errorback);
  },
  /*分销订单列表*/
  getAgentOrder (data, errorback) {
    return request._postBody('/shop/Records/Records/agentOrder', data, errorback);
  },
  /*设置分销设置*/
  getSettingBody (data, errorback) {
    return request._postBody('/shop/AgentGrade/AgentGrade/setting', data, errorback);
  },
  /*提现申请列表*/
  getWithdrawal (data, errorback) {
    return request._postBody('/front/user/yxshopUserWithdrawalRecords/index', data, errorback);
  },
  getSettingTravelCoupon(data, err) {
    return request._get('/shop/AgentGrade/AgentGrade/getSettingTravelCoupon', data, err);
  },
};
export default Distribution;



// WEBPACK FOOTER //
// ./src/api/distribution.js